import React from 'react';
import { insights } from '../data/site';
export function Insights() {
  return <section className="bg-parchment py-24" data-id="element-211" data-mp="1latpe9qeshuh">
      <div className="mx-auto max-w-[1240px] px-6" data-id="element-212" data-mp="1l9sgaasye5fe">
        <p className="eyebrow text-green-dark" data-id="element-213" data-mp="1qag30ka5g03t">Insights</p>
        <h2 className="mt-5 max-w-2xl font-display text-[34px] font-medium leading-[1.15] tracking-[-0.01em] text-ink sm:text-[42px]" data-id="element-214" data-mp="1qazkjzvw0mhb">
          Notes on tax &amp; financial practice in Kenya.
        </h2>
        <div className="double-rule mt-7 w-24 text-ink" aria-hidden="true" data-id="element-215" data-mp="xnc1ipa9m3ws" />

        <div className="mt-12 grid gap-8 lg:grid-cols-3" data-id="element-216" data-mp="12ldk793s417q">
          {insights.map(insight => <article key={insight.title} className="border border-line bg-white p-8" data-id="element-217" data-mp="17ix34mbf9260">
              <div className="h-[2px] w-full bg-ink" aria-hidden="true" data-id="element-218" data-mp="1cbgnc24m6vjs" />
              <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.12em] text-green-dark" data-id="element-219" data-mp="evjav1io4us8">
                {insight.tag}
              </p>
              <h3 className="mt-3 font-display text-[21px] leading-snug text-ink" data-id="element-220" data-mp="js9rbpydxse6">
                {insight.title}
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed text-ink-70" data-id="element-221" data-mp="ter0wozcceoz">
                {insight.description}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}